import React, { useEffect, useState } from "react";
import { useAdvancedValidation } from "hooks/useAdvancedValidation";
import MessageSnackBar from "components/widgets/message-snackbar/MessageSnackBar";
import "./ManageGuestUsers.css";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import {
  IconEdit,
  IconSmallQuestion,
  IconTrash,
  IconPlus,
} from "assets/SVGs/SVGs";
import ConfirmationModal from "components/layout/confirmation-modal/ConfirmationModal";
import { useDispatch, useSelector } from "react-redux";
import { isSessionTimeExpired } from "utility";
import {
  deleteGuestUser,
  getGuestUserList,
} from "redux/ManageGuestUser/actions";
import { useHistory } from "react-router-dom";
import alerts from "constants/alerts";
import SessionExpiredPopup from "components/layout/session-expired-popup/SessionExpiredPopup";
import InformationModal from "components/layout/information-modal/InformationModal";

const ManageGuestUsers = () => {
  const [guestUserPopupMode, setGuestUserPopupMode] = useState("");
  const [verificationPopUp, setVerificationPopUp] = useState(false);
  const [showInformationModal, setShowInformationModal] = useState();
  const guestList = useSelector((store) => store?.guestUser?.guestUserList);
  const loading = useSelector((store) => store?.guestUser?.loading);
  const dispatch = useDispatch();
  const history = useHistory();

  // Initialize validation hook
  const { onApiResponse, snackbarState, dismissSnackbar } = useAdvancedValidation();

  useEffect(() => {
    getGuestUserList(dispatch, history);
  }, []);

  const onRemoveUser = async (data) => {
    let timeDifference = await isSessionTimeExpired();
    if (timeDifference) {
      setGuestUserPopupMode("");
      setVerificationPopUp(true);
      return;
    } else {
      deleteGuestUser(
        dispatch,
        {
          guest_user_id: data?.guest_user_id,
        },
        setGuestUserPopupMode,
        history,
        onApiResponse
      );
    }
  };

  const onAddGuestUser = () => {
    if (guestList && guestList?.length >= 3) {
      onApiResponse(alerts?.guest_user_maximum_allowed, "error");
    } else {
      history.push("/add-edit-guest-user", { mode: "add" });
    }
  };

  const onEditGuestUser = (guest) => {
    history.push("/add-edit-guest-user", { mode: "edit", guestDetail: guest });
  };

  return (
    <>
      <MessageSnackBar
        message={snackbarState?.message}
        isVisible={snackbarState?.show}
        onDismiss={dismissSnackbar}
        type={snackbarState?.type}
        autoHideDuration={snackbarState?.autoHideDuration}
      />
      <MainLayout
      text={titles?.manage_guest_users}
      isBackHide={false}
      isSemiHeader={true}
      white={false}
      isLoading={loading}
      
    >
      <InformationModal
        show={showInformationModal}
        setShow={setShowInformationModal}
        infoText={titles?.modal_texts?.guest_user_help_tip}
      />
      <ConfirmationModal
        show={guestUserPopupMode?.mode === "delete"}
        setShow={setGuestUserPopupMode}
        svgIcon={<IconTrash color="#DB4E3B" width="32" height="37" />}
        title={titles?.delete_guest}
        description={titles?.remove_guest_desc}
        btnText={titles?.remove}
        onClick={() => onRemoveUser(guestUserPopupMode?.detail)}
      />
      <div className="mg_container">
        <div className="mg_desc_container">
          <p className="mg_desc_text">
            {titles?.add_upto_three_guest}
            <IconSmallQuestion
              className="mg_tip_left"
              fillColor={"#fff"}
              onClick={() => setShowInformationModal(true)}
            />
          </p>
          <p className="mg_add_upto_text">{titles?.guest_notification}</p>
        </div>

        <div className="mg_guest_list_container">
          {guestList?.map((guest, index) => {
            return (
              <div className="mg_item_container" key={`guest ${index}`}>
                <div className="mg_guest_info_container">
                  <p className="mg_guest_name">
                    {guest?.guest_user_name ||
                      `${titles?.guest}: ${guest?.guest_user_name}`}
                  </p>
                  <p className="mg_guest_detail">
                    {`${titles?.password}: ${guest?.Password ?? "*******"}`}
                  </p>
                </div>
                <div className="mg_icon_container">
                  <IconEdit
                    className="mg_icon_edit"
                    color="#595252"
                    onClick={() => onEditGuestUser(guest)}
                  />
                  <IconTrash
                    className="mg_icon_delete"
                    color="#595252"
                    onClick={() =>
                      setGuestUserPopupMode({ mode: "delete", detail: guest })
                    }
                  />
                </div>
              </div>
            );
          })}
        </div>
        {guestList?.length < 3 ? (
          <button
            onClick={() => onAddGuestUser()}
            className="mg_add_guest_button"
          >
            <span className="mg_add_guest_button_text">Add a Guest User</span>
            <IconPlus
              className="mg_add_guest_button_icon"
              color="var(--primaryColor)"
            />
          </button>
        ) : null}
      </div>
      {verificationPopUp ? (
        <SessionExpiredPopup
          isVisible={verificationPopUp}
          onClosePopup={() => {
            setVerificationPopUp(false);
          }}
          history={history}
        />
      ) : null}
    </MainLayout>
    </>
  );
};

export default ManageGuestUsers;
